export default {
    events: state => state.events
}



// WEBPACK FOOTER //
// ./src/store/modules/test/getters.js